{
  "title": "Federation",
  "subtitle": "A2A-Workstations — ferngesteuerte Agent-Systeme",
  "add": "Hinzufügen",
  "loading": "Lade…",
  "empty": "Noch keine Workstations registriert",
  "add_first": "Erste Workstation hinzufügen →",
  "delete_confirm": "Workstation entfernen?",
  "info_p1": "Registrierte Workstations sind über ",
  "info_p2": " erreichbar. Der Token ist das ",
  "info_p3": " der Ziel-Workstation.",
  "workstation": {
    "token_ok": "Token konfiguriert",
    "no_token": "Kein Token",
    "tls_on": "TLS-Verify aktiv",
    "tls_off": "TLS-Verify deaktiviert (self-signed OK)",
    "refresh": "A2A-Card neu laden",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "personas": "Personas / Agents",
    "last_seen": "Zuletzt gesehen:",
    "no_card": "Keine A2A-Card — bitte Token prüfen und «Refresh» klicken",
    "tls_label": "TLS-Zertifikat verifizieren",
    "tls_hint": "Aus für self-signed (LAN/Tailnet, --tls-auto)",
    "tls_on_label": "AN",
    "tls_off_label": "AUS",
    "tls_on_title": "Aktuell AN — TLS-Zertifikatskette wird validiert. Klick deaktiviert die Prüfung (nur für self-signed Peers in LAN/Tailnet sinnvoll).",
    "tls_off_title": "Aktuell AUS — Zertifikat wird NICHT geprüft. Nur sicher in vertrauenswürdigen Netzwerken (LAN, Tailnet). Klick aktiviert die Prüfung wieder.",
    "audit_load": "Remote-Audit-Log",
    "audit_loading": "Lade…",
    "audit_empty": "Keine Einträge"
  },
  "add_dialog": {
    "title": "Workstation hinzufügen",
    "subtitle": "A2A-kompatible Workstation registrieren",
    "name_label": "Name",
    "name_hint": "Wird als @-Adresse genutzt:",
    "url_label": "URL",
    "url_hint": "Vollständige URL inkl. Port.",
    "token_label": "Remote-Token (PROJEKTX_REMOTE_TOKEN)",
    "token_placeholder": "optional — für /remote/* Zugriff",
    "tls_label": "TLS-Zertifikat verifizieren",
    "tls_hint": "Aus für self-signed Setups (ProjektX --tls-auto, Tailnet, LAN). An für echte CA-signierte Peers über öffentliches Internet.",
    "tls_warn": "⚠ Diese URL sieht nach LAN/Tailnet aus — TLS-Verify ist hier vermutlich der Grund weshalb die Card nicht erreichbar ist. Häkchen entfernen?",
    "save": "Hinzufügen",
    "saving": "Speichern…",
    "cancel": "Abbrechen",
    "error": "Fehler beim Speichern"
  },
  "clients": {
    "title": "Verbundene Clients",
    "subtitle": "Config-Dateien für ProjektX und andere Clients",
    "add": "Neuen Client anbinden",
    "loading": "Lade…",
    "empty": "Noch keine Clients angebunden",
    "add_first": "Ersten Client anbinden →",
    "delete_confirm": "Client \"{{name}}\" entfernen? Der API-Key wird widerrufen.",
    "remove_title": "Client entfernen"
  },
  "new_client": {
    "title": "Neuen Client anbinden",
    "name_label": "Client-Name",
    "name_placeholder": "z.B. ProjektX Phone, ProjektX Laptop",
    "hint": "Jeder Client erhält einen eigenen API-Key. Der Key wird nur einmalig angezeigt — nach dem Download nicht wiederherstellbar.",
    "cancel": "Abbrechen",
    "create": "Config generieren",
    "creating": "Erstelle…",
    "close": "Schließen",
    "download": "Config herunterladen",
    "error": "Fehler beim Erstellen",
    "success_prefix": "Config für",
    "success_suffix": "wurde generiert. Lade die Datei jetzt herunter — der API-Key kann danach nicht mehr abgerufen werden.",
    "tailscale_no_authkey": "— (Tailscale Admin nicht konfiguriert)",
    "agentlink_not_configured": "— nicht konfiguriert"
  },
  "instances": {
    "title": "Datamining-Instanzen",
    "subtitle": "Externe Claude-Code-Instanzen, die live ins Datamining spiegeln",
    "add": "Neue Instanz",
    "loading": "Lade…",
    "empty": "Noch keine Datamining-Instanzen",
    "sessions": "Sessions",
    "last_activity": "zuletzt",
    "copy_agent_id": "Agent-ID kopieren",
    "rotate_key": "API-Key rotieren",
    "delete": "Instanz löschen",
    "delete_confirm": "Instanz \"{{name}}\" löschen? User, Agent und API-Key werden entfernt.",
    "rotate_confirm": "Key für \"{{name}}\" rotieren? Der alte Key wird ungültig.",
    "new_key_prompt": "Neuer API-Key (einmalig — jetzt kopieren):"
  },
  "new_instance": {
    "title": "Neue Datamining-Instanz",
    "name_label": "Instanz-Name",
    "name_placeholder": "z.B. joshua, claude-laptop",
    "model_label": "Modell",
    "hint": "Legt User + Agent + API-Key an. Der Key wird nur einmalig angezeigt.",
    "cancel": "Abbrechen",
    "create": "Instanz anlegen",
    "creating": "Erstelle…",
    "close": "Schließen",
    "copy": "Config kopieren",
    "error": "Fehler beim Erstellen",
    "success_prefix": "Instanz",
    "success_suffix": "angelegt. Kopiere den Block jetzt — der API-Key wird nicht erneut angezeigt."
  },
  "peers": {
    "title": "Server",
    "subtitle": "gekoppelte HydraHive-Server (über Tailscale)",
    "pair": "Server koppeln",
    "empty": "Noch kein Server gekoppelt",
    "pair_title": "Server koppeln",
    "step1": "1. Eigenen Kopplungscode erzeugen und auf dem anderen Server einfügen",
    "name_ph": "Name dieses Servers",
    "url_hint": "Adresse, unter der der andere Server diesen hier erreicht – am besten die Tailscale-IP.",
    "make_code": "Code erzeugen",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "own_fp": "Fingerprint dieses Servers:",
    "step2": "2. Kopplungscode des anderen Servers hier einfügen",
    "add": "Partner hinzufügen",
    "error": "Aktion fehlgeschlagen",
    "fp": "Fingerprint:",
    "status_pending": "wartet auf Bestätigung",
    "status_active": "aktiv",
    "status_blocked": "gesperrt",
    "block": "Sperren",
    "delete": "Entfernen",
    "delete_confirm": "Kopplung mit {{name}} entfernen?",
    "confirm_hint": "Fingerprint vergleichen: Auf dem anderen Server unter „Server koppeln“ ablesen und hier eintippen.",
    "confirm": "Bestätigen",
    "agents_hint": "Diese Agenten darf der Partner-Server beauftragen:",
    "auto_tools_title": "Führt Werkzeuge ohne Rückfrage aus",
    "auto_tools_warning": "Mindestens ein freigegebener Agent führt Werkzeuge ohne Rückfrage aus. Aufträge vom Partner-Server laufen damit ungebremst – bei diesen Agenten in den Einstellungen „Werkzeuge bestätigen“ einschalten.",
    "call_hint": "Aufruf vom anderen Server: ask_agent(\"<Agent-Name oder ID>@{{server}}\")"
  }
}
